import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import Link from "@khanacademy/wonder-blocks-link";
import {OnePaneDialog} from "@khanacademy/wonder-blocks-modal";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";

type Props = {
    flaggedBy: Array<string | null | undefined> | null | undefined;
    flags: Array<string>;
    onCancel: () => void;
    onClearAllFlags: () => void;
};

export default function ClearFlagsModal({
    flaggedBy,
    flags,
    onCancel,
    onClearAllFlags,
}: Props): React.ReactElement {
    return (
        <OnePaneDialog
            title={t`Flags:`}
            content={
                <View style={styles.content}>
                    {flags.map((flag, index) => {
                        const flaggerKaid = flaggedBy?.[index];
                        return (
                            <Body key={flaggerKaid ?? index}>
                                {flaggerKaid == null ||
                                flaggerKaid === "deleted" ? (
                                    t`Unknown or deleted user`
                                ) : (
                                    <Link
                                        href={`/profile/${flaggerKaid}/discussion`}
                                        target="_blank"
                                    >
                                        {flaggerKaid}
                                    </Link>
                                )}
                                {" - "}
                                {flag}
                            </Body>
                        );
                    })}
                </View>
            }
            footer={
                <View style={styles.footer}>
                    <Button onClick={onCancel} kind="tertiary">
                        {t`Cancel`}
                    </Button>
                    <Strut size={16} />
                    <Button onClick={onClearAllFlags}>
                        {t`Clear all flags`}
                    </Button>
                </View>
            }
            style={styles.dialog}
        />
    );
}

const styles = StyleSheet.create({
    dialog: {
        [mediaQueries.mdOrLarger]: {
            height: "auto",
        },
    },
    content: {
        gap: spacing.xxSmall_6,
    },
    footer: {
        flexDirection: "row",
    },
});
